import { withEditableArea } from '@trendkite/ui';

import EditStoryCompanyBackgroundContainer from './EditStoryCompanyBackgroundContainer';
import StoryCompanyBackgroundDisplay from './StoryCompanyBackgroundDisplay';

export default withEditableArea(
  StoryCompanyBackgroundDisplay,
  EditStoryCompanyBackgroundContainer,
);
